import React from 'react'
import { Button } from 'antd'
import { Switch, Route, Link } from 'react-router-dom'

import Header from './components/Header'

import imgLogo from 'assets/spiffme-tm_600px.png'
import imgIndividual from 'assets/individuals_bg_image.jpg'
import imgBusiness from 'assets/business_bg_image.jpg'
import imgLanding from 'assets/home_bg_image.jpg'

import svgBriefcase from 'assets/web_buttons_briefcase.svg'
import svgDesktop from 'assets/web_buttons_desktop.svg'
import svgDollaBills from 'assets/web_buttons_dollabills.svg'
import svgHandshake from 'assets/web_buttons_handshake.svg'
import svgIncreaseSales from 'assets/web_buttons_increase_sales.svg'
import svgMobilePhone from 'assets/web_buttons_mobile_phone.svg'

import UserTypeDialog from './components/UserTypeDialog'
import GetAppDialog from './components/GetAppDialog'
import SignIn from 'modules/User/SignIn'
// import SignUp from 'modules/User/SignUp'
import NewManufacturer from 'modules/User/NewManufacturer'
import ConfirmUser from 'modules/User/ConfirmUser'
import ForgotPassword from 'modules/User/ForgotPassword'
import ConfirmPassword from 'modules/User/ConfirmPassword'
import NewPassword from 'modules/User/NewPassword'
import FieldRep from 'modules/User/FieldRep'

import imgAppStore from 'assets/appstore.svg'
import imgGooglePlay from 'assets/googleplay.svg'

import './styles.css'

const SIGNIN = 'SIGNIN'
const SIGNUP = 'SIGNUP'
class Landing extends React.Component {
  state = {
    visibleUserSelect: false,
    visibleGetApp: false,
    userSelectMode: SIGNIN,
    transparentHeader: true
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault()

        document.querySelector(this.getAttribute('href')).scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
      })
    })
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = event => {
    const scrollTop = document.documentElement.scrollTop
    if (scrollTop < 40) {
      this.setState({ transparentHeader: true })
    } else {
      this.setState({ transparentHeader: false })
    }
  }

  showUserSelect = (visible, mode = SIGNIN) => () => {
    this.setState({ visibleUserSelect: visible, userSelectMode: mode })
  }

  showGetApp = visible => () => {
    this.setState({ visibleGetApp: visible })
  }

  onManufacturer = () => {
    this.props.changeRoute('/user/manufacturer')
  }

  onUser = () => {
    if (this.state.userSelectMode === SIGNIN) {
      this.props.changeRoute('/user/signin')
    } else {
      this.props.changeRoute('/user/signup')
    }
  }

  render () {
    // const visibleText = (!this.state.visibleUserSelect && !this.state.visibleGetApp) && this.props.location.pathname === "/"
    const { transparentHeader } = this.state
    const { changeRoute } = this.props
    return (
      <div className='landing'>
        <Header
          transparent={transparentHeader}
          onSignIn={this.showUserSelect(true)}
          onSignUp={this.showUserSelect(true, SIGNUP)}
        />
        <section className='landing-img'>
          <img className='back' src={imgLanding} alt='background' />
          <div className='mask' />

          <div className='text'>
            <img className='logo' src={imgLogo} alt='logo' />
            <h2 className='description'>
              The Premier Single-Source Spiff/Referral Management System
            </h2>
            <p className='descpara'>
              <b>Get started making more money today!</b>
            </p>

            <div className='topics container'>
              <div className='topic'>
                <div className='topic-title'>For Individuals</div>
                <div className='topic-text'>
                  Now you can get paid more at your existing job for selling
                  products & referring services in a variety of industries such
                  as tourism, construction, training, & entertainment.
                </div>
                <div className='actions'>
                  <a
                    href='https://itunes.apple.com/us/app/spiff-me/id1345621267?ls=1&mt=8'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img
                      className='store'
                      src={imgAppStore}
                      alt='Get App from App Store'
                    />
                  </a>
                  <a
                    href='https://play.google.com/store/apps/details?id=com.spiffme'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img
                      className='store'
                      src={imgGooglePlay}
                      alt='Get App from Google Play'
                    />
                  </a>
                </div>
                <Button className='button' type='primary' href='#individual'>
                  Learn more
                </Button>
              </div>

              <div className='topic'>
                <div className='topic-title'>For Businesses</div>
                <div className='topic-text'>
                  Incentivize product sales and referrals by directly rewarding
                  your sales representatives and referrers. Introduce new
                  products, acquire new customers and new markets. Keep your
                  sales team and referral network motivated and focused on{' '}
                  <strong>YOUR</strong> brand.
                </div>
                <Button className='button' type='primary' href='#business'>
                  Learn more
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="landing-section section-description">
          <div className="container">
            <h2 className="section-title">
              The Premier Single-Source Spiff/Referral Management System
            </h2>
            <div className="section-content">
            Now you can get paid more at your existing job for selling products and referring services in a variety of industries such as tourism, construction, training, and entertainment.
            <br /><br /><br/><b>Get started making more money today!</b>
            </div>
          </div>
        </section> */}

        <section className='landing-section section-video' id='intro'>
          <div className='video-wrapper'>
            <iframe
              width='1920'
              height='1080'
              src='https://www.youtube.com/embed/ZCvOwDQ8CUk?loop=1'
              frameBorder='0'
              allow='autoplay; encrypted-media'
              allowFullScreen
              title='intro-video'
            />
          </div>
        </section>

        <section className='landing-section section-individual' id='individual'>
          <img
            className='section-background'
            src={imgIndividual}
            alt='Background'
          />
          <div className='topics container'>
            <div className='topic'>
              <img className='topic-icon' src={svgHandshake} alt='Briefcase' />
              <div className='topic-content'>
                <div className='topic-title'>
                  Get paid more for your sales and referrals
                </div>
                <div className='topic-text'>
                  SpiffMe will help you find companies that pay you directly for
                  your sales and referrals. See which companies are paying the
                  best spiffs, and on which products and services. Get signed up
                  with the companies you want and get paid more for what you are
                  already doing.
                </div>
              </div>
            </div>
            <div className='topic justify-right text-right'>
              <div className='topic-content'>
                <div className='topic-title'>
                  Easily create, manage, and submit your claims
                </div>
                <div className='topic-text'>
                  SpiffMe makes it simple to create, organize, and keep tabs on
                  all of your claims. Create claims by including the required
                  receipt or referral information, as well as selecting the
                  products sold and/or the services referred. Submit and track
                  your claims while you are on the go.
                </div>
              </div>
              <img className='topic-icon' src={svgMobilePhone} alt='Mobile' />
            </div>
            <div className='topic'>
              <img className='topic-icon' src={svgDollaBills} alt='Bills' />
              <div className='topic-content'>
                <div className='topic-title'>
                  Know who is paying you and when
                </div>
                <div className='topic-text'>
                  SpiffMe tracks your claims through the entire approval and
                  invoicing process, so that you know exactly the status of
                  every claim, no matter what company you are spiffing for.
                </div>
              </div>
            </div>
            <div className='actions'>
              <a
                href='https://itunes.apple.com/us/app/spiff-me/id1345621267?ls=1&mt=8'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  className='store'
                  src={imgAppStore}
                  alt='Get App from App Store'
                />
              </a>
              <a
                href='https://play.google.com/store/apps/details?id=com.spiffme'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  className='store'
                  src={imgGooglePlay}
                  alt='Get App from Google Play'
                />
              </a>
            </div>
          </div>
        </section>

        <section className='landing-section section-video' id='intro'>
          <div className='video-wrapper'>
            <iframe
              width='1920'
              height='1080'
              src='https://www.youtube.com/embed/wF5bHEYUBlA?loop=1'
              frameBorder='0'
              allow='autoplay; encrypted-media'
              allowFullScreen
              title='business-video'
            />
          </div>
        </section>

        <section className='landing-section section-business' id='business'>
          <h1 className='section-title'>For Businesses</h1>
          <img
            className='section-background'
            src={imgBusiness}
            alt='Background'
          />
          <div className='topics container'>
            <div className='topic'>
              <img className='topic-icon' src={svgBriefcase} alt='Briefcase' />
              <div className='topic-content'>
                <div className='topic-title'>Energize Your Sales Network</div>
                <div className='topic-text'>
                  A well run SPIFF program that directly incentivizes sales and
                  referrals can help you:
                  <ul>
                    <li>Introduce new products.</li>
                    <li>Acquire new customers.</li>
                    <li>Break into new markets.</li>
                    <li>
                      Sell aging or discontinued products, or products under
                      attack from your competitors.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='topic justify-right text-right'>
              <div className='topic-content'>
                <div className='topic-title'>Easily Stay in Control</div>
                <div className='topic-text'>
                  SpiffMe is a simple solution that can work with your existing
                  sales/referral process. You are in total control. You decide
                  who can rep for and refer to your company. You set the spiff
                  amount and the length of time it is available for each. You
                  choose to approve or deny claims, by viewing sales receipts,
                  product serial numbers, or only approving referrals that led
                  to new customers. You set your own terms on when and how you
                  pay claims.
                </div>
              </div>
              <img className='topic-icon' src={svgDesktop} alt='Bills' />
            </div>
            <div className='topic'>
              <img className='topic-icon' src={svgIncreaseSales} alt='Mobile' />
              <div className='topic-content'>
                <div className='topic-title'>
                  Turbo-Charge Your Business and Watch Your Sales Grow
                </div>
                <div className='topic-text'>
                  One single place to manage your spiff and referral program.
                  Automated feedback to your clients on their claim status as
                  you review, approve, and pay, helps them stay motivated and
                  engaged with you. Quickly spot the trends. Know who sending
                  you the best leads or selling the most products. Know which
                  products and referrals are moving and which need more
                  attention. Keep your sales team and referral network
                  motivated, happy, and focused on YOUR brand.
                </div>
              </div>
            </div>
            <Button
              className='button'
              type='primary'
              onClick={() => changeRoute('/user/manufacturer')}
            >
              Sign Up Now
            </Button>
          </div>

          <footer className='footer'>
            <Link to='/help/policy'>Privacy Policy</Link>
            <Link to='/help/terms'>Terms of Use</Link>
            <a href='mailto:support@spiffme.com?'>Contact Us</a>
          </footer>
        </section>

        <UserTypeDialog
          mode={this.state.userSelectMode}
          visible={this.state.visibleUserSelect}
          close={this.showUserSelect(false)}
          onSalesRep={this.showGetApp(true)}
          onUser={this.onUser}
          onManufacturer={this.onManufacturer}
        />
        <GetAppDialog
          visible={this.state.visibleGetApp}
          close={this.showGetApp(false)}
        />
        <Switch>
          <Route path='/user/field_rep' component={FieldRep} />
          <Route path='/user/signin' component={SignIn} />
          {/* <Route path="/user/signup/:business" component={SignUp} /> */}
          <Route path='/user/confirm/:email' component={ConfirmUser} />
          <Route path='/user/manufacturer' component={NewManufacturer} />
          <Route path='/user/password/new' component={NewPassword} />
          <Route path='/user/password/forgot' component={ForgotPassword} />
          <Route
            path='/user/password/confirm/:email'
            component={ConfirmPassword}
          />
        </Switch>
      </div>
    )
  }
}

export default Landing
